import { track } from '@bnnvara/analytics/src/track';
import { useBrand } from '@bnnvara/brand';
import { useLazyQuery } from '@apollo/client';
// import { FollowButton, BaseButton } from '@bnnvara/buttons';
import { FollowButton } from '@bnnvara/buttons';
// import { Modal } from '@bnnvara/modal';
import { useAccount, useLogin } from '@bnnvara/accounts';
import React, { useCallback, useEffect, useContext, useState } from 'react';
// import { EditorialNotificationSettings } from '../Profile/NotificationSettings/EditorialNotificationSettings';
import { useNotifications } from '../../hooks/notifications';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import Notification from '../Notification';
import { Copy } from './Copy';
import { createNotification } from './createNotification';
import { FollowBrandContext } from './FollowBrandContext';
import * as S from './styled';
import { useIsFollowedByUser } from './useIsFollowedByUser';
import { FetchNotificationSettings } from '../../api/queries/me/notifications.gql';

const FollowBrand = () => {
  const brand = useBrand();
  const { isLoggedIn } = useLogin();
  const { profile } = useAccount();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { followedBrands } = useContext(FollowBrandContext);
  const { isFollowedByUser, toggle } = useIsFollowedByUser(brand.id);
  const isDesktop = useIsDesktop();
  const hasSubscriptions = Boolean(followedBrands?.length);
  const { addNotification } = useNotifications();

  const [getNotificationSettings] = useLazyQuery(FetchNotificationSettings, {
    variables: {
      UID: profile.UID,
    },
    skip: !profile.UID,
    fetchPolicy: 'no-cache',
  });

  const handleClick = useCallback(async () => {
    const result = await toggle();

    if (result === true) {
      addNotification(
        createNotification({
          hasSubscriptions,
          slug: brand.slug,
          brandName: brand.name,
        })
      );
      track('header', 'click', 'volgen');

      const resultNotificationSettings = await getNotificationSettings();

      /** Check if the user wants email notifications and if not show consent dialog */
      const hasNotifyEmailChecked =
        resultNotificationSettings?.data?.me?.notificationSettings
          ?.editorialNotificationPerEmail;

      if (!hasNotifyEmailChecked) setIsModalOpen(true);
    } else if (result === false) {
      track('header', 'click', 'ontvolgen');
    }
  }, [
    addNotification,
    brand.name,
    brand.slug,
    getNotificationSettings,
    hasSubscriptions,
    toggle,
  ]);

  // const handleCloseModal = useCallback(() => setIsModalOpen(false), []);

  useEffect(() => {
    if (isModalOpen && isLoggedIn) {
      getNotificationSettings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen]);

  return (
    <>
      <S.NotificationPosition>
        <S.FollowButtonContainer>
          <FollowButton
            onClick={handleClick}
            isFollowedByUser={isFollowedByUser}
          />
        </S.FollowButtonContainer>
        <S.NotificationContainer>
          {!isFollowedByUser && (
            <Notification
              visible
              type="bnnvaraFollowBrandNotification"
              horizontalPosition={isDesktop ? 'left' : 'up'}
              direction={isDesktop ? 'left' : 'up'}
              delay={1000}
              hideAfter={7000}
              onlyShowOnceEvery24Hrs
              showCloseButton={false}
            >
              {Copy}
            </Notification>
          )}
        </S.NotificationContainer>
      </S.NotificationPosition>
      {/* <Modal onRequestClose={handleCloseModal} isOpen={isModalOpen}>
        <S.InnerModal>
          <S.NotificationContent>
            <EditorialNotificationSettings UID={profile.UID} inModal />
          </S.NotificationContent>
          <S.ButtonGroup>
            <BaseButton
              rel="alternate"
              onClick={handleCloseModal}
              className="cancelButton"
            >
              Bewaren
            </BaseButton>
          </S.ButtonGroup>
        </S.InnerModal>
      </Modal> */}
    </>
  );
};

export default FollowBrand;
